export const tedeeConfig = {
  common: {
    saving: "Saving...",
    connected: "Connected",
    disconnected: "Disconnected",
    lockFallbackNamed: "Lock {id}",
    deviceFallbackNamed: "Tedee Device {id}",
    unitFallback: "Unit",
    unitFallbackNamed: "Unit {id}",
  },

  credentials: {
    title: "Tedee configuration",
    apiVersionInUse: "API version in use:",
    savedKey: "Key saved",
    noKey: "No key",
    keyLabel: "Personal Access Key",
    keyPlaceholderSaved: "•••••••• (saved, change optional)",
    keyPlaceholderNew: "Enter your Tedee Personal Access Key",
    keyHintSaved: "You can leave it empty if you already have a saved key.",
    keyHintNew: "Get your key from the Tedee portal.",
    testing: "Testing...",
    test: "Test connection",
    save: "Save credentials",
  },

  selector: {
    title: "Lock selector for this property",
    subA: "Select only the locks that apply to",
    subBold: "this property",
    subB: ". You'll then see only the selected ones in the PMS.",
    selectedCount: "{count} selected",
    hintNoKeyA: "Enter your Personal Access Key and press",
    hintNoKeyBold: "Test connection",
    hintNoKeyB: "to load your locks.",
    emptyDevices:
      "We couldn't find any lock or gate in your Tedee account. Make sure the device is registered and shared with the account whose key you saved above.",
    placeholder: "Select locks…",
    summaryCount: "{count} lock(s) selected",
    summaryEmpty: "No locks selected",
    save: "Save locks for this property",
  },

  pms: {
    title: "Control and assignment (PMS)",
    subA:
      "Only the locks you saved for this property appear here. Assign each one to",
    subBold1: "Main door",
    subOr: "or",
    subBold2: "Unit",
    subEnd: ".",
    assignedCount: "{count} assigned",
    empty: {
      A: "You don't have any saved locks for this property yet. Use the",
      bold: "selector",
      B: "above and then save.",
    },
    assignmentLabel: "Assignment",
    assignmentNone: "Unassigned",
    assignmentGate: "Main door (Gate)",
    assignmentCommon: "Main door (shared)",
    assignmentUnit: "Apartment door",
    hintNone: "It won't be controlled from the PMS.",
    hintGate: "Gate: it can only be pressed to open (no lock/PIN support).",
    hintUnit: "It will be linked to this property for control/PINs.",
    unitLabel: "Unit / Accommodation",
    unitSelect: "Select a unit",
    unitHint: "Select which unit this lock opens.",
    nameLabel: "Name (optional)",
    namePlaceholder: "E.g. Main door / Apt 101",
    nameHint: "This name is saved when you save the lock selector again.",
    actions: {
      lock: "Lock",
      unlock: "Unlock",
      createPin: "Create PIN",
      pinHistory: "PIN history",
      openGate: "Open gate (pulse)",
      refresh: "Refresh status",
    },
    save: "Save assignment",
    tipA: "Tip: Assign a main door or unit and press",
    tipBold: "Save assignment",
    tipB: ". The buttons are enabled once the device is assigned.",
  },

  pinHistory: {
    title: "PIN history",
    loading: "Loading history…",
    empty: "No PINs recorded for this lock.",
    colAlias: "Alias",
    colPin: "PIN",
    colValidity: "Validity",
    colState: "Status",
    createdPrefix: "Created:",
    fromLabel: "From:",
    toLabel: "To:",
    revokeTitle: "Delete / Revoke PIN",
    noteA: '* "Active" is calculated by comparing the current date/time with',
    noteMid: "and",
    noteEnd: ".",
    close: "Close",
  },

  pinModal: {
    title: "Create PIN",
    nameLabel: "Name / Label",
    namePlaceholder: "E.g. Cleaning / Guest / Technician",
    pinLabel: "PIN",
    pinPlaceholder: "6 digits",
    generateTitle: "Generate",
    pinHint: "If you leave it empty, the backend generates one.",
    modeLabel: "Mode",
    modeTimeLimited: "With dates",
    modeOngoing: "No dates (until revoked)",
    validFrom: "Valid from",
    validTo: "Valid to",
    tipLabel: "Tip:",
    tipText: "For a guest, use a PIN with check-in/check-out dates.",
    cancel: "Cancel",
    creating: "Creating...",
    create: "Create PIN",
  },

  toast: {
    noLocksFound: "No locks (type 2/5) were found in Tedee.",
    loadStatusError: "Couldn't load lock status",
    loadStatusError2: "Error loading lock status",
    needKey: "You must enter a Personal Access Key or have a saved key.",
    connectionOk: "Connection successful. {count} device(s) found.",
    testError: "Error testing the connection",
    needValidKey:
      "You must enter a valid Personal Access Key (at least 10 characters).",
    credentialsSaved: "Credentials saved successfully",
    saveCredentialsError: "Error saving credentials",
    saveCredentialsErrorPrefix: "Error saving credentials: ",
    needOneDevice: "You must select at least one device for this property.",
    devicesSaved: "Devices saved for this property",
    devicesSaveError: "Couldn't save the devices",
    saveErrorPrefix: "Error saving: ",
    gateNoLock:
      "Gate (type 5) doesn't support locking. It can only be pressed to open.",
    locked: "Lock locked",
    lockError: "Couldn't lock",
    lockError2: "Error locking",
    gateOpened: "Gate opened (pulse)",
    unlocked: "Lock unlocked",
    unlockError: "Couldn't unlock",
    unlockError2: "Error unlocking",
    needUnitForApartment:
      "Select the unit for the locks assigned as 'Apartment door'.",
    bindingsSaved: "Assignment saved successfully",
    bindingsSaveError: "Couldn't save the assignment",
    bindingsSaveErrorPrefix: "Error saving assignment: ",
    gateNoPin: "Gate (type 5) doesn't support PINs.",
    assignFirst:
      "First assign the lock (main door or unit) and save to enable control.",
    needPinName: "You must provide a name/label for the PIN.",
    needValidDates: "You must provide valid from and valid to.",
    pinCreated: "PIN created successfully",
    pinCreateError: "Couldn't create the PIN",
    pinCreateError2: "Error creating PIN",
    gateNoPinHistory: "Gate (type 5) doesn't support PIN history.",
    historyLoadError: "Couldn't load the history",
    historyLoadError2: "Error loading history",
    noProviderPinId:
      "This PIN has no provider_pin_id. It can't be revoked in Tedee.",
    pinRevoked: "PIN revoked",
    revokeError: "Couldn't revoke",
    revokeError2: "Error revoking PIN",
  },

  confirm: {
    revokePin: 'Are you sure you want to revoke/delete the PIN "{alias}"?',
  },

  pinState: {
    active: "Active",
    upcoming: "Upcoming",
    expired: "Expired",
    revoked: "Revoked",
    none: "No dates",
  },
};
